import { useState } from 'react';
import DataMap from '../../components/DataMap/DataMap';
import ActionGrid from '../../components/ActionGrid/ActionGrid';
import { Icon } from 'leaflet';
import dayjs from 'dayjs';
import {useDeviceFilter} from '../../hooks/useFilter';
import Card from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { DateField } from '@mui/x-date-pickers/DateField';
import SearchIcon from '@mui/icons-material/Search';
import { fetchNetworkTester } from '../../Helpers/fetchDevices';

const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})

const actions = [
    'excellent',
    'good',
    'medium',
    'bad',
    'error',
    'gateway',
];

const NetworkQuality = () => {
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [filters, setFilters] = useState({
        fromDate: dayjs().add(0, "day").startOf("day"),
        deviceStates: {
          excellent: true,
          good: true,
          medium: true,
          bad: true,
          error: true,
        },
        tester : ""
      });
    
    const {devices, statusCounts, handleSearchClick } = useDeviceFilter(filters, fetchNetworkTester, "networkTester");
  

    const handleMarkersSelected = (results) => {
        if (results) {
          setSelectedDevices(results);
        }
    };
    
    return (
        <>
            <div className="mb-4">
                <ActionGrid actions = {actions} statusCounts = {statusCounts}/>
            </div>
            <div className="mb-4">
                <Card sx={{ maxWidth: 400, p: 2 }}>
                    <CardHeader sx={{ pb: 1 }}>Φίλτρα </CardHeader>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, p: 0 }}>
                        <DateField
                        label="Ημερομηνία"
                        value={filters.fromDate}
                        onChange={(e) => setFilters(prev => ({ ...prev, fromDate: e.target.value }))}
                        format="DD-MM-YYYY"
                        fullWidth
                        />
                        <FormControl fullWidth>
                        <InputLabel>Επιλογή Tester</InputLabel>
                        <Select
                            value={filters.tester}
                            label="Επιλογή Tester"
                            onChange={(e) => setFilters(prev => ({ ...prev, tester: e.target.value }))}
                        >
                            <MenuItem value="">Επιλέξτε</MenuItem>
                            <MenuItem value="0018b20000022c25">0018b20000022c25</MenuItem>
                            <MenuItem value="0018b20000022c75">0018b20000022c75</MenuItem>
                        </Select>
                        </FormControl>
                        <Button
                            variant="contained"
                            startIcon={<SearchIcon />}
                            sx={{ mt: 2, alignSelf: 'flex-start' }}
                            onClick={handleSearchClick}
                            >
                            Αναζήτηση
                        </Button>
                    </CardContent>
                </Card>

            </div>
            <div className="mb-4">
                <DataMap markers ={devices} customIcon = {customIcon} deviceType ={"networkTester"} onMarkersSelected={handleMarkersSelected} modalFetcher={null}/> 
            </div>
        </>
    
    );
};
    
export default NetworkQuality;